const formTypes = {
    SET_PERIOD: 'SET_PERIOD',
    SET_PORTAL: 'SET_PORTAL',
    SET_HOLD_OVER: 'SET_HOLD_OVER',
    MODIFY_LAST_PRICE: 'MODIFY_LAST_PRICE',
    SET_RECEIVED_FORM:"SET_RECEIVED_FORM",
    SET_RECEIVED_EXCEL: 'SET_RECEIVED_EXCEL'
};

export default formTypes